export function findAllNode(entry, predicate) {
  const results = [];

  _query(entry);

  return results;

  function _query(node) {
    if (predicate(node)) {
      return results.push(node);
    }
    if ('children' in node) {
      for (const children of node.children) {
        _query(children);
      }
    }
    return results;
  }
}
